import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'home_product_list_title',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'download_btn',
      dataType: ['design', 'design'],
      onlyEnglish: ['self_textAlign', false],
      englishTitleLeft: ['flex-start', 'self_marginLeft'],
      englishTitleRight: ['flex-end', 'self_marginRight']
    },
    {
      flag: 'view_more_btn',
      dataType: ['design'],
      onlyEnglish: [false],
      englishTitleLeft: ['self_marginLeft'],
      englishTitleRight: ['self_marginRight']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
